import { createContext, useContext, useEffect, useState } from "react";
import {
  addNewUser,
  deleteUser,
  fetchAllUsers,
  updateUser,
} from "../../../api/userServices";
import { useDispatch, useSelector } from "react-redux";
import { setMaxUsersReached } from "../../../store/userSlice";
import { toast } from "react-toastify";
const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedOption, setselectedOption] = useState(null);
  const [loading, setloading] = useState(null);
  const dispatch = useDispatch();
  const { maxUsersReached } = useSelector((state) => state.user);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        setloading("userFetching");
        const response = await fetchAllUsers();
        setUsers(response.users);
        setloading(null);
      } catch (error) {
        toast.error(error.error);
        setloading(null);
      }
    };

    fetchUsers();
  }, []);

  // Register or update user
  const saveUser = async (userData) => {
    setloading("addUpdateUser");

    if (selectedUser) {
      try {
        const response = await updateUser(selectedUser._id, userData);
        if (response.status) {
          setUsers((prevUsers) =>
            prevUsers.map((user) =>
              user._id === selectedUser._id
                ? { ...selectedUser, ...response.user }
                : user,
            ),
          );
          toast.success("User updated successfully!");
        }
      } catch (error) {
        toast.error(error.error);
      }
    } else {
      try {
        const response = await addNewUser(userData);
        setUsers((prevUsers) => [...prevUsers, response.user]);
        toast.success("User added successfully!");
      } catch (error) {
        console.log(error);
        toast.error(error.error);
      }
    }
    clearStates();
  };
  const clearStates = () => {
    setloading(null);
    setSelectedUser(null);
    setselectedOption(null);
  };
  const deleteSelectedUser = async (user) => {
    try {
      setloading("deletingUser");
      await deleteUser(user._id);
      toast.success("User deleted successfully");
      setUsers((prevUsers) => prevUsers.filter((u) => u._id !== user._id));
    } catch (error) {
      console.log(error);
    }
    setloading(null);
  };

  const handleEditUser = (user) => {
    setSelectedUser(user);
    setselectedOption("update");
  };

  const handleAddUser = () => {
    setSelectedUser(null);
    setselectedOption("register");
  };

  return (
    <UserContext.Provider
      value={{
        users,
        selectedUser,
        selectedOption,
        loading,
        setSelectedUser,
        setselectedOption,
        saveUser,
        deleteSelectedUser,
        handleEditUser,
        handleAddUser,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

// Custom Hook to use the context
export const useUserContext = () => {
  return useContext(UserContext);
};
